<div class="app-container">
  <site-header></site-header>
  <main class="app-main">
    <router-outlet></router-outlet>
  </main>
  <site-footer></site-footer>
</div>
